import React from 'react';
import { BasePage } from '@ctrip/nfes'; //next-mvc
import Session from '@/components/Session';
import Services from '@/components/Services';
import Destination from '@/components/Destination';
import Why from '@/components/Why';
import Who from '@/components/Who';
import Header from '@/components/Header';
import Footer from '@/components/Footer';

import './style/globals.scss';
import './style/page.scss';

export default class IndexPage extends BasePage {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <React.Fragment>
                <Header />
                <Session
                    className='hero'
                    style={{
                        backgroundColor: `#4a4645`,
                        backgroundImage: `url('https://ak-d.tripcdn.com/images/0a10o120009rm17stA187.png')`,
                    }}
                >
                    <div className='banner'>
                        <div className='info'>
                            <div className='title'>Long Stay Made Easy.</div>
                            <div className='subtitle-default'>Find your perfect long stay hotel or service apartment!</div>
                            <div className='desc'>
                                Special discount up to <strong>50%</strong> off
                            </div>
                        </div>
                    </div>
                </Session>
                <Services />
                <Destination />
                <Why />
                <Who />
                <Footer />
            </React.Fragment>
        );
    }
}
